import { SwitchInput } from '@framework/form/inputs/SwitchInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { SWITCH_EVIDENCE_CARD_LAYOUT } from '@framework/form/item/formItemLayouts.ts';
import { SwitchEvidenceCard } from '@framework/ui/components/configuration-card/SwitchEvidenceCard.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { Flex } from 'antd';

/** Shape condiviso del flag `layout.hideLabel` (SingleSelect, MultiSelect, Upload). */
export const hideLabelConfigSchema = yup.boolean().required().default(false);

/**
 * Campo di configurazione "Nascondi etichetta", condiviso dai widget che
 * supportano `layout.hideLabel`.
 */
export function HideLabelConfigInput() {
  return (
    <SwitchEvidenceCard>
      <FormItem
        name="layout.hideLabel"
        label="Nascondi etichetta"
        layout={SWITCH_EVIDENCE_CARD_LAYOUT}
      >
        <SwitchInput name="layout.hideLabel" align="start">
          <Flex vertical>
            <b>Nascondi etichetta</b>
            <span>
              L&apos;etichetta viene nascosta solo visivamente: resta
              disponibile agli screen reader per l&apos;accessibilità.
            </span>
          </Flex>
        </SwitchInput>
      </FormItem>
    </SwitchEvidenceCard>
  );
}
